import { useState, useCallback } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import ComicGrid from './components/ComicGrid';
import PopularRanking from './components/PopularRanking';
import RecommendedSection from './components/RecommendedSection';

export default function Home() {
  const [activeCategory, setActiveCategory] = useState('all');

  const handleCategoryChange = useCallback((slug: string) => {
    setActiveCategory(slug);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav
          activeCategory={activeCategory}
          onCategoryChange={handleCategoryChange}
        />
        <ComicGrid categorySlug={activeCategory} />
        <PopularRanking />
        <RecommendedSection />

        <section className="w-full py-10 md:py-14 bg-background-100">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6 text-center">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-4">
              海量韩漫，免费畅读
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto mb-6">
              韩漫网站为您提供最全的韩国漫画大全，支持下拉式阅读，漫画在线观看体验流畅舒适。每天更新最新韩漫，热门韩国漫画一网打尽。
            </p>
            <div className="flex flex-wrap items-center justify-center gap-3">
              <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-background-50">
                <i className="ri-checkbox-circle-fill text-primary-500"></i>
                <span className="text-sm text-foreground-700 font-medium">完全免费</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-background-50">
                <i className="ri-checkbox-circle-fill text-primary-500"></i>
                <span className="text-sm text-foreground-700 font-medium">每日更新</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-background-50">
                <i className="ri-checkbox-circle-fill text-primary-500"></i>
                <span className="text-sm text-foreground-700 font-medium">高清画质</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-background-50">
                <i className="ri-checkbox-circle-fill text-primary-500"></i>
                <span className="text-sm text-foreground-700 font-medium">下拉式阅读</span>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '韩漫免费-漫画在线观看下拉式-好看的韩国漫画大全-韩漫网站',
            description:
              '作为韩漫爱好者，您可以在韩漫网站免费观看下拉式韩国漫画大全，在线浏览各种热门作品，轻松又愉快。',
            url: 'https://manhwa-reader.example.com/',
            isPartOf: {
              '@type': 'WebSite',
              name: '韩漫阅读',
              url: 'https://manhwa-reader.example.com',
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: '首页',
                  item: 'https://manhwa-reader.example.com/',
                },
              ],
            },
          }),
        }}
      />
    </>
  );
}